import { render, staticRenderFns } from "./WorkPlace.vue?vue&type=template&id=14248b3c&scoped=true"
import script from "./WorkPlace.vue?vue&type=script&lang=js"
export * from "./WorkPlace.vue?vue&type=script&lang=js"
import style0 from "./WorkPlace.vue?vue&type=style&index=0&id=14248b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14248b3c",
  null
  
)

export default component.exports